"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Circular = require("./Circular.styles");

var _excluded = ["inverse", "backdrop", "speed", "center", "vertical", "content", "size", "color", "className"];

var Loader = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var inverse = props.inverse,
      backdrop = props.backdrop,
      speed = props.speed,
      center = props.center,
      vertical = props.vertical,
      content = props.content,
      size = props.size,
      color = props.color,
      className = props.className,
      rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var hasContent = !!content;
  return /*#__PURE__*/_react["default"].createElement(_Circular.StyledCircular, (0, _extends2["default"])({
    role: "progressbar"
  }, rest, {
    ref: ref,
    color: color,
    className: (0, _classnames["default"])("eui-loader-wrapper eui-loader-speed-".concat(speed, " eui-loader-").concat(size), (0, _defineProperty2["default"])({
      'backdrop-wrapper': backdrop,
      'has-content': hasContent,
      'eui-loader-vertical': vertical,
      'eui-loader-inverse': inverse,
      'eui-loader-center': center
    }, className, className))
  }), backdrop && /*#__PURE__*/_react["default"].createElement("div", {
    className: 'eui-loader-backdrop'
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'eui-loader'
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: 'eui-loader-spin'
  }), hasContent && /*#__PURE__*/_react["default"].createElement("span", {
    className: 'eui-loader-content'
  }, content)));
});

Loader.defaultProps = {
  color: 'primary',
  speed: 'normal',
  size: 'sm'
};
Loader.displayName = 'Loader';
Loader.propTypes = {
  className: _propTypes["default"].string,
  center: _propTypes["default"].bool,
  backdrop: _propTypes["default"].bool,
  inverse: _propTypes["default"].bool,
  vertical: _propTypes["default"].bool,
  content: _propTypes["default"].string,
  size: _propTypes["default"].oneOf(['lg', 'md', 'sm', 'xs']),
  speed: _propTypes["default"].oneOf(['normal', 'fast', 'slow']),
  color: _propTypes["default"].oneOf(['base', 'primary', 'secondary', 'error', 'warning', 'success', 'info']),
  "static": true
};
var _default = Loader;
exports["default"] = _default;